import { api } from './config/axios';
import { store } from '../store';

export const getManualFundingAccount = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/manual-funding', {}, config);
};

export const updateManualFundingAccount = async (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/manual-funding', payload, config);
};
